import * as React from "react";
import type { SVGProps } from "react";
const SvgSheetWithChartAndArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={61}
    fill="none"
    viewBox="0 0 72 61" {...props}
  >
    <path
      fill="url(#sheet-with-chart-and-arrow_svg__a)"
      d="M.384 20.101c2.447 4.873 7.32 13.854 14.182 22.792 3.867 5.047 7.779 8.937 11.144 11.8a60 60 0 0 0 5.485 4.173 8.3 8.3 0 0 0 7.91.743L66.88 47.613c.175-.066.328-.153.48-.263 1.487-1.005 1.618-3.256.11-4.414-4.349-3.343-11.713-9.505-18.29-17.503-.022-.044-.066-.065-.087-.11-.285-.327-.547-.677-.83-1.004-6.207-7.605-10.468-13.658-12.719-16.957a4.32 4.32 0 0 0-4.982-1.683l-6.075 2.032-12.455 4.174-9.571 3.19c-2.076.7-3.06 3.06-2.076 5.026"
      opacity={0.6}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.392}
      d="M3.356 14.55c2.403 4.894 7.21 13.92 13.963 22.922 3.824 5.092 7.692 9.003 11.057 11.887a71 71 0 0 0 5.441 4.218c2.316 1.595 5.31 1.923 7.91.808L69.61 42.651c.175-.066.328-.153.481-.262 1.486-1.005 1.639-3.234.153-4.392-4.305-3.387-11.625-9.615-18.137-17.678a.5.5 0 0 0-.087-.11c-.284-.328-.547-.677-.809-1.005-6.118-7.67-10.358-13.745-12.565-17.066a4.334 4.334 0 0 0-4.96-1.726l-6.097 1.966L15.09 6.443 5.497 9.546a3.602 3.602 0 0 0-2.12 5.004z"
    />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.437}
      d="M11.529 29.125S-.293 36.948 8.906 46.978c7.867 8.566 22.377 3.562 35.728-14.05C55.93 18.002 68.693 5.415 68.693 5.415"
    />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.437}
      d="m64.147 6.618 4.633-1.42-.35 4.391"
    />
    <path
      fill="#81B3FF"
      d="M24.487 29.365 16.4 15.948l4.567-1.901 8.195 13.198z"
    />
    <path
      fill="#58DFD6"
      d="m31.195 26.438-6.6-10.423 4.568-1.923 6.708 10.226z"
      opacity={0.7}
    />
    <path
      fill="#C9F7F4"
      d="m37.903 23.617-3.977-5.747 4.567-1.923 4.108 5.55z"
    />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.393}
      d="m21.82 30.436 23.644-9.899"
    />
    <path
      fill="#FFCE00"
      d="m42.798 33.058 2.426 1.508a1.5 1.5 0 0 0 1.595 0l1.355-.852c.459-.284.764-.743.83-1.268l.24-1.551a1.42 1.42 0 0 0-.655-1.42L45.9 27.791a1.12 1.12 0 0 0-1.136-.044l-1.77.94c-.394.196-.656.59-.678 1.027l-.175 2.098c-.043.502.197.983.634 1.267z"
    />
    <path
      fill="#81B3FF"
      d="M6.765 46.082a2.141 2.141 0 1 0 0-4.283 2.141 2.141 0 0 0 0 4.283"
    />
    <defs>
      <linearGradient
        id="sheet-with-chart-and-arrow_svg__a"
        x1={0.103}
        x2={68.387}
        y1={33.166}
        y2={32.57}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSheetWithChartAndArrow;
